import { ShoppingCart } from '@phosphor-icons/react/dist/ssr';
import { useCart } from "context/CartContex";
import { useState } from 'react';
import * as S from './styles';
//components
import LayoutOrder from '../LayoutOrder';

export default function Create() {
    const {
        state,
    } = useCart();

    //forms
    const [isFormOpen, setIsFormOpen] = useState(false);

    return (
        <S.Main>
            {!isFormOpen ? (
                <S.ContentButtonPopUp>
                    <S.ButtonPopUp
                        onClick={() => setIsFormOpen(true)}>
                        {
                            state.items.length > 0 &&
                            <S.Title>{state.items.length}</S.Title>
                        }
                        <ShoppingCart size={24} />
                    </S.ButtonPopUp>
                </S.ContentButtonPopUp>
            ) : (
                <LayoutOrder
                    isOpenFormsCart={isFormOpen}
                    setIsOpenFormsCart={() => setIsFormOpen(false)}
                />
            )}
        </S.Main>

    )
}